module.exports = __webpack_public_path__ + "static/img/03.61cb186.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/03.jpg
// module id = kkni
// module chunks = 2